import { List } from "@mui/material";
import { getTagsWithUnresolvedParent } from "../helpers/Helpers";

const getTagKey = (prefix, tag) => {
  return `${prefix}-${tag.AssetTagId ?? tag.TCTagLayerId ?? tag.AssetId ?? "no-asset"}-${tag.TagIdentifier}`;
};

export const PreSaveWarningsContent = ({ tags, allTags }) => {
  const syncDisabledTags = tags.filter((tag) => tag.SyncToHub === false);
  const unresolvedParentTags = getTagsWithUnresolvedParent(
    tags,
    allTags ?? tags
  );

  if (syncDisabledTags.length === 0 && unresolvedParentTags.length === 0) {
    return null;
  }

  return (
    <>
      {syncDisabledTags.length > 0 && (
        <>
          <p>
            The following tags you are about to save have SyncToHub set to
            False, and will be skipped by Dashboard when syncing tags to the
            Hub. Continue?
          </p>
          <List>
            {syncDisabledTags.map((tag) => (
              <li
                key={getTagKey(
                  "sync",
                  tag
                )}>{`${tag.TagName} (${tag.TagIdentifier})`}</li>
            ))}
          </List>
        </>
      )}
      {unresolvedParentTags.length > 0 && (
        <>
          <p>
            The following tags have a Parent Tag Identifier that does not match
            any tag on the same Asset. The save may fail unless a valid tag with
            that Tag Identifier exists on the same Asset. Continue?
          </p>
          <List>
            {unresolvedParentTags.map((tag) => (
              <li key={getTagKey("parent", tag)}>
                {`${tag.TagName} (${tag.TagIdentifier}) — Parent Tag Identifier: ${tag.ParentTagIdentifier}`}
              </li>
            ))}
          </List>
        </>
      )}
    </>
  );
};
